export default {
  methods: {
    _downloadCSV (datas, name) {
      const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
      const header = Object.keys(datas[0])
      let csv = datas.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      csv.unshift(header.join(','))
      csv = csv.join('\r\n')

      var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      // IE11 & Edge
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, name)
      } else {
        // In FF link must be added to DOM to be clicked
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(csvData)
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/download-csv.js